import { attach, createEffect, createEvent, createStore, type EffectParams, sample } from 'effector'

import { type NotificationArgs, showErrorNotificationFx, showNotificationFx } from '@/shared/ui'
import { createHideFx } from '@/shared/ui/modal'

import { chatapi, type MessageReportRequest } from '../../api'

export const showFx = createEffect<{ message_id: string; channel: string }, string>()
export const hideFx = createHideFx(showFx)

export const backButtonClicked = createEvent()
export const reportReasonClicked = createEvent<{ reason_code: string }>()
export const reportButtonClicked = createEvent<{ reason_message: string }>()

export const $step = createStore<'step_one' | 'step_two'>('step_one')
    .on(reportReasonClicked, () => 'step_two')
    .on(backButtonClicked, () => 'step_one')
    .reset(showFx)

export const $selectedReason = createStore<string>('')
    .on(reportReasonClicked, (_state, { reason_code }) => reason_code)
    .reset(showFx)

export const $showProps = createStore<EffectParams<typeof showFx> | null>(null).reset(hideFx)

sample({
    clock: showFx.finally,
    fn: ({ params }) => params,
    target: $showProps,
})

const messageReportFx = attach({ effect: chatapi.messageReport })

export const $interactionDisabled = messageReportFx.pending

// -- Report Message --
sample({
    clock: reportButtonClicked,
    source: {
        showProps: $showProps,
        reason_code: $selectedReason,
    },
    fn: ({ showProps, reason_code }, { reason_message }): MessageReportRequest => ({
        message_id: showProps!.message_id,
        channel: showProps!.channel,
        reason_code: reason_code,
        reason_message: reason_message,
    }),
    target: messageReportFx,
})

sample({
    clock: messageReportFx.failData,
    target: showErrorNotificationFx,
})

sample({
    clock: messageReportFx.done,
    target: hideFx,
})

sample({
    clock: messageReportFx.done,
    fn: (): NotificationArgs => ({ notification: 'report_message_sent' }),
    target: showNotificationFx,
})
